<template>
  <div class="apply-success">
    <div class="container text-center">
    <div v-if="$attrs.application">
      <div v-html="t('form.submitted_msg')" />
      <img src="/img/quotation.png"></img>
    </div>
    <div v-else-if="$attrs.quotation">
      <h3 v-html="t('insurance.quotation_msg')" />
      <img src="/img/quotation.png"></img>
    </div>
    <div v-else>
    <h3 v-html="t('insurance.applied_msg')" />
    <img src="/img/handling.png">
  </div>
  <div class="text-center">
      <button @click="doneHandle" class="btn btn-secondary btn-md">
        {{ t('filter.done') }}
      </button>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: "ApplySuccess",
  inheritAttrs: false,
  computed: {},
  mounted: function () {},
  methods: {
    doneHandle: function (e) {
      if (this.$attrs.application) {
        window.close();
        return;
      }
      window.location.href = "/insurance";
    },
  },
};
</script>
